// Initialise le cookie 'rlx-consent' si non défini
if (!$.cookie('rlx-consent')) {
    $.cookie('rlx-consent', 'false', { expires: 365, path: '/' });
}

// Fonction pour vérifier et mettre à jour le cookie 'rlx-consent'
function checkAndSetConsentCookie() {
    const consentCookie = document.cookie
        .split('; ')
        .find(row => row.startsWith('_consentik_cookie='));

    if (consentCookie) {
        try {
            const cookieValue = consentCookie.split('=')[1];
            const consentObj = JSON.parse(decodeURIComponent(cookieValue));

            if (consentObj[0]?.categoriesSelected) {
                const categories = consentObj[0].categoriesSelected;
                const hasRolexConsent = categories.includes('statistics');

                // Met à jour 'rlx-consent' en fonction de la catégorie
                $.cookie('rlx-consent', hasRolexConsent ? 'true' : 'false', { expires: 365, path: '/' });
            }
        } catch (error) {
            console.error('Erreur de parsing JSON dans _consentik_cookie:', error);
        }
    }
}

// Ajoute des écouteurs de clic sur les boutons
const buttonsToObserve = ['#cookies-submit', '#cookies-dismiss', '.cookies-btn.btn-all', '.cookies-btn.btn-select'];

buttonsToObserve.forEach(selector => {
    $(document).on('click', selector, () => {
        setTimeout(checkAndSetConsentCookie, 100); // Délai pour permettre au cookie d'être mis à jour
    });
});

// Vérifie une première fois au chargement
checkAndSetConsentCookie();
